enum OrigemProdutoLote {
    Interno = 1,
    Fracionamento = 2,
    Dinamizacao = 3,
}

export default OrigemProdutoLote;
